import LanguageSelector from "@/components/languageSelector/LanguageSelector";
import PspButton from "@/components/pspButton/PspButton";
import PspLogo from "@/components/pspLogo/PspLogo";
import PspTextInput from "@/components/pspTextInput/pspTextInput";
import { translate } from "@/config/translator";
import { useCode } from "./code/useCode";
import { Dispatch, SetStateAction } from "react";

type CodeProps = {
  nextStage: () => void;
  code: string;
  setCode: Dispatch<SetStateAction<string>>;
};

export function Code({ nextStage, code, setCode }: CodeProps) {
  const {
    onKeyDownCodeInput,
    onSendCode,
    onVerify,
    navigate,
    lang,
    onChangeCode,
    codeWasSentMessage,
    sendCodeCooldown,
    verifyButtonRef,
    email,
  } = useCode({ setCode, nextStage, code });

  return (
    <div className="fixed inset-0 justify-center items-center flex bg-white flex-col gap-8">
      <div className="absolute top-16 tablet:top-20 w-full flex flex-row justify-center">
        <PspLogo />
      </div>

      {/* LANGUAGE SELECTOR */}
      <div className="absolute top-36 tablet:top-10 tablet:right-10">
        <LanguageSelector />
      </div>
      <div className="w-2/3 tablet:w-1/2 desktop:w-1/3 flex-col flex gap-4">
        <div className="flex flex-row gap-4 items-end">
          <PspTextInput
            label="code"
            placeholder="passwordResetCodePlaceholder"
            onChange={onChangeCode}
            onKeyDown={onKeyDownCodeInput}
            value={code}
          />
          <div className="bottom-0 min-w-fit">
            <PspButton
              size="large"
              className="grow"
              onClick={onSendCode}
              disabled={sendCodeCooldown !== null}
            >
              {translate("sendCode", lang) +
                (sendCodeCooldown !== null ? ` (${sendCodeCooldown})` : "")}
            </PspButton>
          </div>
        </div>
        <div className="w-full flex flex-row justify-end gap-4">
          {/* BACK BUTTON */}
          <PspButton onClick={() => navigate(-1)} size="large">
            {translate("back", lang)}
          </PspButton>

          {/* VERIFY BUTTON */}
          <PspButton
            appearance="primary"
            onClick={onVerify}
            size="large"
            disabled={!/\d{3}-\d{3}/.test(code)}
            customRef={verifyButtonRef}
          >
            {translate("verify", lang)}
          </PspButton>
        </div>
      </div>
      {codeWasSentMessage && (
        <div className="absolute bottom-10 text-font-secondary">
          {translate("codeWasSentTo", lang, { "{email}": email })}
        </div>
      )}
    </div>
  );
}
